import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp } from "../../core/components/commonApp";
import { SheetEventType } from "../../../siteManagement/sheet";
import { DialogHelper } from "../../core/util/dialogHelper";
import { ServiceHoursPosEntity } from "./serviceHours";
import { KeyValuePair } from "../../commonInterfaces";
import React from "react";

export default class ServiceHoursPos extends React.Component<ServiceHoursPosProps, any>{
    common = new AppHelper();
    translations: {};

    constructor(props) {
        super(props);
        this.common.init(this);
        this.props.dataSources["typesOfDayDataSource"] = this.props.typesOfDay;
    }

    validateLocal = () => {
        if ((this.props.entity.StartMinute != null) && (this.props.entity.EndMinute != null)) {
            if (this.props.entity.StartMinute >= this.props.entity.EndMinute) {
                DialogHelper.alert(this.translations["WebSMS.SLA.InvalidTimePeriod"]);
                return false;
            }
        }
        return true;
    }

    apply = () => {
        if (this.validateLocal()) {
            if (this.common.validate()) {
                this.common.setEntityDirtyState(false);
                this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, this.props.entity);
                this.common.sheetWrapper.hide()
            }
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface ServiceHoursPosProps extends AppBaseProps {
    entity: ServiceHoursPosEntity;
    typesOfDay: KeyValuePair<number, string>[];
}